import { render, staticRenderFns } from "./ApprovalDetails.vue?vue&type=template&id=86cd1bf4&"
import script from "./ApprovalDetails.vue?vue&type=script&lang=js&"
export * from "./ApprovalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports